import PageTemplate from '../containers/common/PageTemplate';

import Container from '../containers/sign';

export default function Sign() {
  return (
    <>
      <PageTemplate>
        <Container />
      </PageTemplate>
    </>
  );
}
